import { useMemo } from "react"
import { graphMargin, scrollBarSize } from "../../../constants"

type useGridProps = {
	topMargin?: boolean
	horizontalScroll?: boolean
	verticalScroll?: boolean
	containLabel?: boolean
}
export const useGrid = ({
	topMargin,
	horizontalScroll,
	verticalScroll,
	containLabel
}: useGridProps) => {
	return useMemo(
		() => ({
      top: (topMargin === true) ? graphMargin : 0,
      bottom: graphMargin + (horizontalScroll === true ? scrollBarSize.y : 0),
      left: graphMargin,
      right: graphMargin + (verticalScroll === true ? scrollBarSize.x : 0),
      containLabel
		}),
		[topMargin, horizontalScroll, verticalScroll, containLabel]
	)
}